<script lang="ts">
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'
	import { Icon } from '@repo/commons/components'
	import type { IconVariant } from '../Icon/Icon.svelte'

	interface Props {
		row: Record<string, string>
		key: string
		label?: string
	}

	let { row, key, label }: Props = $props()

	const status = $derived(row[key])

	// Status configuration
	const statusConfig: Record<
		string,
		{ icon: IconName; bgColor: string; textColor: string; variant: IconVariant }
	> = {
		success: {
			icon: 'success',
			bgColor: '#0ACC920D',
			textColor: '#067A57',
			variant: 'success'
		},
		warning: {
			icon: 'warning',
			bgColor: '#FFC02E0D',
			textColor: '#8F6C1A',
			variant: 'warning'
		},
		error: {
			icon: 'error',
			bgColor: '#E4485B0D',
			textColor: '#E4485B',
			variant: 'danger'
		},
		info: {
			icon: 'info',
			bgColor: '#26B0FF0D',
			textColor: '#1A74A8',
			variant: 'info'
		},
		unmapped: {
			icon: 'error',
			bgColor: '#FFC02E0D',
			textColor: '#8F6C1A',
			variant: 'warning'
		}
	}

	// Get status config based on status value
	const config = $derived(
		statusConfig[status?.toLowerCase() as keyof typeof statusConfig] || statusConfig.success
	)
</script>

<div class="label-container" style="background: {config.bgColor};">
	<Icon name={config.icon} size="sm" variant={config.variant} />
	<div class="label" style="color: {config.textColor};">
		{label ?? status}
	</div>
</div>

<style>
	.label-container {
		display: flex;
		width: fit-content;
		height: 24px;
		padding: 2px 8px;
		justify-content: center;
		align-items: center;
		gap: 4px;
		border-radius: 16px;
	}
	.label {
		font-family: 'inter', sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		text-transform: capitalize;
	}
</style>
